<template>
  <LocationFinderSelect v-model="select"
                        :select="false"
                        :studios="apiJson.studios"
                        :inverted="true" />
</template>
<script setup>
import { ref } from 'vue';
import LocationFinderSelect from './components/fields/LocationFinderSelect.vue';
const select = ref('');

const props = defineProps({
  apiJson: {
    type: Object,
    default: () => {}
  }
})

</script>